'use strict';
{
    var app = angular.module('tf.alerts', [])
        .controller('alertsCtrl', ['$scope', '$uibModal', '$state', '$resource', 'gridUtil', 'uiGridConstants', 'uiGridExporterConstants', 'uiGridGroupingConstants', '$localStorage', '$timeout', '$http', 'csv', '$sanitize', 'terms', '$aside', 'userConfig', function alertsController($scope, $uibModal, $state, $resource, gridUtil, uiGridConstants, uiGridExporterConstants, uiGridGroupingConstants, $localStorage, $timeout, $http, csv, $sanitize, terms, $aside, userConfig) {

            $scope.newAlert = function () {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/alerts/newAlert/newAlert.tpl.html',
                    controller: 'newAlertsCtrl as newAlertsCtrl',
                    size: 'lg',
                    resolve: {
                    }
                });
            };

        }])

        .controller('newAlertsCtrl', ['$scope', '$http', '$uibModal', '$uibModalInstance', '$timeout', 'terms', '$state', function newAlertsController($scope, $http, $uibModal, $uibModalInstance, $timeout, terms, $state) {

            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

        }]);
}
